import { defineMessages } from 'react-intl';

export default defineMessages({
  // About
  description: {
    id: 'product.license.description',
    defaultMessage: 'A web-based license-managing system',
    description: 'Description of license product',
  },

  // Payment
  monthlyPayment: {
    id: 'product.license.feature.monthlyPayment',
    defaultMessage: 'per month (net price)',
    description: 'Info about monthly payment',
  },

  // Starter
  starter: {
    id: 'product.license.feature.starter',
    defaultMessage: 'Starter',
    description: 'Header text for package',
  },

  limitMessageStarter: {
    id: 'product.license.feature.limitMessageStarter',
    defaultMessage: '3 months minimum',
    description: 'Info text regarding product pricing limitation',
  },

  featureApiKeyStats: {
    id: 'product.license.feature.apiKeyStats',
    defaultMessage: `
      See statistics on API keys (e.g. last validation call)
    `,
    description: 'Info text regarding feature in license pricing',
  },
  featureDashboard: {
    id: 'product.license.feature.dashboard',
    defaultMessage: `
      Dashboard with overview on your server API keys and your personal API keys
    `,
    description: 'Info text regarding feature in license pricing',
  },
  featureProductDefinition: {
    id: 'product.license.feature.productDefinition',
    defaultMessage: 'Definition of products',
    description: 'Info text regarding feature in license pricing',
  },
  featureLicenseDefinition: {
    id: 'product.license.feature.licenseDefinition',
    defaultMessage: `
      Definition of licenses: multiple licenses can be defined for one product
    `,
    description: 'Info text regarding feature in license pricing',
  },
  featureManageCustomers: {
    id: 'product.license.feature.manageCustomers',
    defaultMessage: 'Manage customers and one billing data per customer',
    description: 'Info text regarding feature in license pricing',
  },
  featureApiKeyDefinition: {
    id: 'product.license.feature.apiKeyDefinition',
    defaultMessage: 'Definition of API keys',
    description: 'Info text regarding feature in license pricing',
  },
  featureApiKeyValidity: {
    id: 'product.license.feature.apiKeyValidity',
    defaultMessage: 'Specify validity intervals for API keys',
    description: 'Info text regarding feature in license pricing',
  },
  featureLimits: {
    id: 'product.license.feature.limits',
    defaultMessage: 'Define hard and soft limits for API key credits',
    description: 'Info text regarding feature in license pricing',
  },
  featureActiveApiKeys: {
    id: 'product.license.feature.activeApiKeys',
    defaultMessage: 'Up to 1000 active API keys',
    description: 'Info text regarding feature in license pricing',
  },
  featureRequestsPerMonth: {
    id: 'product.license.feature.requestsPerMonth',
    defaultMessage: 'Up to 100k requests per month',
    description: 'Info text regarding feature in license pricing',
  },

  // Business
  business: {
    id: 'product.license.feature.business',
    defaultMessage: 'Business',
    description: 'Header text for package',
  },

  limitMessageBusiness: {
    id: 'product.license.feature.limitMessageBusiness',
    defaultMessage: '6 months minimum',
    description: 'Info text regarding product pricing limitation',
  },
  featureHeaderTextBusiness: {
    id: 'product.license.feature.headerTextBusiness',
    defaultMessage: 'All Starter features',
    description:
      'Entry line for professional license type on price page, stating that it includes all standard benefits in addition to the professional benefits',
  },

  featureUnlimitedApiKeys: {
    id: 'product.license.feature.unlimitedApiKeys',
    defaultMessage: 'Unlimited API keys',
    description: 'Info text regarding feature in license pricing',
  },
  featureProductVersionLifeTime: {
    id: 'product.license.feature.productVersionLifeTime',
    defaultMessage: 'Define life time of product versions',
    description: 'Info text regarding feature in license pricing',
  },
  featureMultipleProductsPerLicense: {
    id: 'product.license.feature.multipleProductsPerLicense',
    defaultMessage: 'Assign multiple products to one license',
    description: 'Info text regarding feature in license pricing',
  },
  featureEMailNotification: {
    id: 'product.license.feature.eMailNotification',
    defaultMessage: `
      E-Mail notification (e.g. API key creation, expiring API keys)
    `,
    description: 'Info text regarding feature in license pricing',
  },
  featureValidityAutoRenew: {
    id: 'product.license.feature.validityAutoRenew',
    defaultMessage: 'Auto-Renew feature of API key validities',
    description: 'Info text regarding feature in license pricing',
  },

  featureRequestPerMonthNote: {
    id: 'product.license.feature.requestPerMonthNote',
    defaultMessage: `
      For more requests per month than the Starter pack, a personalized pricing needs to be arranged
    `,
    description: 'Info text regarding feature in license pricing',
  },

  // On Premise
  onPremise: {
    id: 'product.license.feature.onPremise',
    defaultMessage: 'On Premise',
    description: 'Header text for package',
  },

  limitMessageOnPremise: {
    id: 'product.license.feature.limitMessageOnPremise',
    defaultMessage: '6 months minimum',
    description: 'Info text regarding product pricing limitation',
  },
  featureHeaderTextOnPremise: {
    id: 'product.license.feature.featureHeaderTextOnPremise',
    defaultMessage: 'All Business features',
    description:
      'Entry line for professional license type on price page, stating that it includes all standard benefits in addition to the professional benefits',
  },

  featureDockerized: {
    id: 'product.license.feature.dockerized',
    defaultMessage: 'Fully dockerized in-house setup',
    description: 'Info text regarding feature in time pricing',
  },
  featureLicenseManagingInHouse: {
    id: 'product.license.feature.licenseManagingInHouse',
    defaultMessage: 'All license managing data stays in house',
    description: 'Info text regarding feature in time pricing',
  },
});



// WEBPACK FOOTER //
// ./src/routes/license/messages.js